import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./alternativeAppointmentPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";

function AlternativeAppointmentPopup({date, onClose }: IPopupWithoutProps & { date: string }) {

    return (
        <article className={popupStyles.popup}>
            <h2 className={popupStyles.popup__title}>    {t("ALTERNATIVE_APPOINTMENT_POPUP_TITLE")}</h2>
            <p className={popupStyles.popup__text}>    {t("ALTERNATIVE_APPOINTMENT_POPUP_TEXT")} {date} </p>
            <img
                src={doctor}
                alt={t("ALTERNATIVE_APPOINTMENT_POPUP_IMAGE_ALT")}
                className={popupStyles.popup__img}
            />
            <button
                className={`button hover ${popupStyles.popup__nextBtn}`}
                onClick={onClose}
            >
                {t("ALTERNATIVE_APPOINTMENT_POPUP_BUTTON")}
            </button>
        </article>
    );
}

export default AlternativeAppointmentPopup;
